import React from "react";
import {
  FiSearch,
  FiMoon,
  FiSun,
  FiUser,
  FiSettings,
  FiBell,
  FiLogOut,
  FiAlignLeft,
  FiArrowRight
} from "react-icons/fi";

const Header = ({
  isMobileMenuOpen,
  isMiniMenu,
  darkMode,
  toggleSidebar,
  toggleMobileMenu,
  closeMobileMenu,
  toggleDarkMode
}) => {

  return (
    <header className="nxl-header">
      <div className="header-wrapper">

        {/* HEADER LEFT */}
        <div className="header-left d-flex align-items-center gap-4">

          {/* MOBILE MENU */}
          <a onClick={toggleMobileMenu} className="nxl-head-mobile-toggler" id="mobile-collapse">
            <div className="hamburger hamburger--arrowturn">
              <div className="hamburger-box">
                <div className="hamburger-inner"></div>
              </div>
            </div>
          </a>

          {isMobileMenuOpen && (
            <div className="nxl-menu-overlay" onClick={closeMobileMenu}></div>
          )}

          {/* SIDEBAR TOGGLE */}
          <div className="nxl-navigation-toggle">
            <a href="#!" onClick={toggleSidebar}>
              {isMiniMenu ? <FiArrowRight size={18}/> : <FiAlignLeft size={18}/>}
            </a>
          </div>

        </div>

        {/* HEADER RIGHT */}
        <div className="header-right ms-auto">
          <div className="d-flex align-items-center">

            {/* SEARCH */}
            <div className="dropdown nxl-h-item nxl-header-search">
              <a href="#!" className="nxl-head-link me-0" data-bs-toggle="dropdown">
                <FiSearch size={26}/>
              </a>

              <div className="dropdown-menu dropdown-menu-end nxl-h-dropdown nxl-search-dropdown">

                <div className="input-group search-form">
                  <span className="input-group-text">
                    <FiSearch size={26}/>
                  </span>

                  <input
                    type="text"
                    className="form-control search-input-field"
                    placeholder="Search...."
                  />

                  <span className="input-group-text">
                    <button type="button" className="btn-close"></button>
                  </span>
                </div>

              </div>
            </div>

            {/* DARK MODE */}
            <div className="nxl-h-item dark-light-theme">
              <a onClick={toggleDarkMode} className="nxl-head-link me-0">
                {darkMode ? <FiSun size={26}/> : <FiMoon size={26}/>}
              </a>
            </div>

            {/* USER PROFILE */}
            <div className="dropdown nxl-h-item">
              <a href="#!" data-bs-toggle="dropdown">
                <img
                  src="/images/avatar/userprofile.jpg"
                  alt="user"
                  className="img-fluid user-avtar me-0"
                />
              </a>

              <div className="dropdown-menu dropdown-menu-end nxl-h-dropdown nxl-user-dropdown">

                <div className="dropdown-header">
                  <div className="d-flex align-items-center">

                    <img
                      src="/images/avatar/userprofile.jpg"
                      alt="user"
                      className="img-fluid user-avtar"
                    />

                    <div>
                      <h6 className="text-dark mb-0">
                        Alexandra Della
                        <span className="badge bg-soft-success text-success ms-1">
                          PRO
                        </span>
                      </h6>
                      <span className="fs-12 fw-medium text-muted">
                        alex@example.com
                      </span>
                    </div>

                  </div>
                </div>

                <div className="dropdown-divider"></div>

                <a href="#!" className="dropdown-item">
                  <FiUser style={{marginRight:8}}/>
                  <span>Profile Details</span>
                </a>

                <a href="#!" className="dropdown-item">
                  <FiSettings style={{marginRight:8}}/>
                  <span>Account Settings</span>
                </a>

                <a href="#!" className="dropdown-item">
                  <FiBell style={{marginRight:8}}/>
                  <span>Notifications</span>
                </a>

                <div className="dropdown-divider"></div>

                <a href="/login" className="dropdown-item">
                  <FiLogOut style={{marginRight:8}}/>
                  <span>Logout</span>
                </a>

              </div>

            </div>

          </div>
        </div>

      </div>
    </header>
  );
};

export default Header;